import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { useField, ErrorMessage } from "formik";

// App
import { CheckboxListProps, Options } from "../../../../types";

const CheckboxList: React.FC<CheckboxListProps> = ({
  columns: col = 1,
  name,
  options,
  label,
  isRequired,
    onChange,
    labelStyle
}) => {
  const [field, meta] = useField(name);
  const { onChange: fieldOnChange, ...fieldProps } = field;

  const handleCheckboxChange = (optionId: string) => {
    const updatedOptions = field.value.includes(optionId)
      ? field.value.filter((id: string) => id !== optionId)
      : [...field.value, optionId];
    // Formik default handleChange
    fieldOnChange({ target: { name: field.name, value: updatedOptions } });
    // Custom onChange provided by the parent component
    if (onChange) {
      onChange(updatedOptions);
    }
  };

  const checkboxesInColumns = options?.reduce(
    (columns: Options[][], checkbox, index) => {
      const columnIndex = index % col; // Adjust the number of columns as needed
      columns[columnIndex] = columns[columnIndex] || [];
      columns[columnIndex].push(checkbox);
      return columns;
    },
    []
  );

  return (
    <FormGroup row tag="fieldset" className="mb-3">
          <Label style={{ ...labelStyle }}>
        {label}
        {isRequired && " *"}
      </Label>
      {checkboxesInColumns?.map((column, columnIndex) => (
        <Col key={columnIndex}>
          {column.map((option) => (
            <FormGroup check key={option.value}>
              <Label check>
                <Input
                  type="checkbox"
                  {...fieldProps}
                  value={option.value}
                  id={`${name}-${option.value}`}
                  name={name}
                  checked={field.value?.includes(option.value)}
                  onChange={() => handleCheckboxChange(option.value)}
                />
                {option.label}
              </Label>
            </FormGroup>
          ))}
        </Col>
      ))}

      {meta?.error && (
        <ErrorMessage
          render={(msg) => (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {msg}
            </div>
          )}
          name={name}
        />
      )}
    </FormGroup>
  );
};

export default CheckboxList;
